import React from 'react';
import { useNavigate } from 'react-router-dom';

const CookiePolicyPage = () => {
  const navigate = useNavigate();

  return (
    <div style={{ background: 'var(--bg-page)', paddingTop: '80px', minHeight: '100vh' }}>
      <div className="container" style={{ padding: '3rem 1.2rem', maxWidth: '900px', margin: '0 auto' }}>
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'none',
            border: 'none',
            color: '#22c55e',
            cursor: 'pointer',
            marginBottom: '2rem',
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
          }}
        >
          ← Back
        </button>

        <h1 className="heading-1" style={{ marginBottom: '2rem' }}>Cookie Policy</h1>
        <p className="body-small" style={{ color: 'var(--text-muted)', marginBottom: '2rem' }}>Last updated: January 2025</p>

        <div style={{ color: 'var(--text-secondary)', lineHeight: '1.8' }}>
          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>1. What Are Cookies</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Cookies are small text files that are stored on your computer or mobile device when you visit our website. 
            They help us provide you with a better experience by remembering your preferences and understanding how you use our site.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>2. Types of Cookies We Use</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            <strong>Essential Cookies:</strong> Required for the website to function properly. These cannot be disabled.<br /><br />
            <strong>Analytics Cookies:</strong> Help us understand how visitors interact with our website by collecting anonymous information.<br /><br />
            <strong>Functional Cookies:</strong> Remember your preferences and settings to provide enhanced features.<br /><br />
            <strong>Marketing Cookies:</strong> Used to track visitors across websites to display relevant advertisements.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>3. How We Use Cookies</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            We use cookies to improve your browsing experience, analyze site traffic, personalize content, 
            and serve targeted advertisements. The information collected through cookies helps us optimize our website and services.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>4. Managing Cookies</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            You can control and manage cookies through your browser settings. Most browsers allow you to refuse cookies, 
            delete existing cookies, or be notified when cookies are being sent. Please note that disabling cookies may 
            affect the functionality of our website.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>5. Third-Party Cookies</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            Some cookies on our site are placed by third-party services such as analytics providers. 
            These third parties have their own privacy policies governing the use of cookies.
          </p>

          <h2 className="heading-3" style={{ marginBottom: '1rem', marginTop: '2rem' }}>6. Contact Us</h2>
          <p className="body-medium" style={{ marginBottom: '1rem' }}>
            If you have any questions about our Cookie Policy, please contact us at:<br />
            Email: info@ayurmedglobal.com<br />
            Phone: +91-9958096324
          </p>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicyPage;
